var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4537 18.8786C24.6928 18.8786 22.9638 18.6032 21.3254 18.0618C20.5225 17.7879 19.5356 18.0391 19.0456 18.5424L15.8116 20.9837C12.0612 18.9817 9.75096 16.6722 7.77631 12.9499L10.1458 9.80025C10.7614 9.18547 10.9822 8.28742 10.7176 7.4448C10.1738 5.79776 9.89762 4.0696 9.89762 2.30796C9.89769 1.03534 8.86235 0 7.58981 0H2.30788C1.03534 0 0 1.03534 0 2.30788C0 16.8946 11.867 28.7615 26.4537 28.7615C27.7262 28.7615 28.7615 27.7261 28.7615 26.4536V21.1864C28.7615 19.9139 27.7261 18.8786 26.4537 18.8786Z",
    fill: "#7CB93C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.056b1581a5ebd30df785b68116ce04a1.svg";
export { ForwardRef as ReactComponent };